import { api } from './client';

export type AllPublicationMediaType = 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM' | 'REELS';

export interface AllPublicationItem {
  mediaId: string;
  accountId: string;
  accountName: string;
  username: string;
  mediaType: AllPublicationMediaType;
  permalink: string;
  thumbnailUrl: string | null;
  publishedAt: string;
  likes: number;
  comments: number;
}

export interface AllPublicationsFeed {
  publications: AllPublicationItem[];
  page: number;
  totalPages: number;
  hasMore: boolean;
  totalCount: number;
  cachedCount: number;
}

export interface AllPublicationInsights {
  views: number;
  reach: number;
  shares: number;
  saved: number;
  er: number;
}

export interface InsightsRequestItem {
  mediaId: string;
  accountId: string;
  mediaType: AllPublicationMediaType;
  likes: number;
  comments: number;
}

export type PublicationsPlatform = 'all' | 'instagram' | 'tiktok';

export const allPublicationsApi = {
  async getFeed(page: number = 1, platform: PublicationsPlatform = 'all'): Promise<AllPublicationsFeed> {
    const q = platform === 'all' ? '' : `&platform=${platform}`;
    return api.get<AllPublicationsFeed>(`/all-publications?page=${page}${q}`);
  },

  async getInsights(items: InsightsRequestItem[]): Promise<Record<string, AllPublicationInsights>> {
    const response = await api.post<{ insights: Record<string, AllPublicationInsights> }>(
      '/all-publications/insights',
      { items },
    );
    return response.insights;
  },
};
